import {
  Avatar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { notaHoverColor } from '../../../../../constants/ColorsConst';
import { notaToPonderacionHelper } from '../../../../../helpers';
import { getFilesArchivos } from '../../../../archivos/HelpersArchivos';
import FieldNotaEstudiante from './FieldNotaEstudiante';

const CalculadoraNotasEstudianteView = () => {
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const notasEvaluativasStore = Redux.useSelector(
    (state) => state.notasEvaluativas,
  );

  const [actividades, setActividades] = React.useState([]);
  const [notaDef, setNotaDef] = React.useState(0);

  const estudiante = notasEvaluativasStore.calculadora.estudiante;

  React.useEffect(() => {
    let lista = [];
    notasEvaluativasStore.calculadora.actividades.forEach((actividad) => {
      const nota = estudiante.notasEvaluativas.find(
        (notaEva) => notaEva.ptevaInstrumento.id === actividad.id,
      );
      lista.push({ nota, actividad });
    });
    setActividades(lista);
    getTotalDef();
  }, []);

  React.useEffect(() => {
    getTotalDef();
  }, [actividades]);

  function getTotalDef() {
    let t = 0;
    actividades.forEach((nx) => {
      t += notaToPonderacionHelper(
        parseFloat(nx.nota?.nota ?? '0'),
        nx.actividad.ponderacion,
        entidadesStore.ajustes.ponderacion,
      );
    });
    setNotaDef(t);
  }

  return (
    <div>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
        <Avatar
          alt={estudiante.usuario.perfil.pnombre}
          src={
            estudiante.usuario.perfil.avatar
              ? getFilesArchivos(estudiante.usuario.perfil.avatar)
              : `static/images/${
                  estudiante.usuario.perfil.gender ? 'userf.png' : 'userm.png'
                }`
          }
          sx={{ width: 70, height: 70 }}
        />
        <Stack>
          <Typography variant="body1" color="initial">
            {estudiante.usuario.perfil.tipoDni}-{estudiante.usuario.perfil.dni}
          </Typography>
          <Typography
            variant="body1"
            color="initial"
            sx={{ fontWeight: 'bold' }}
          >
            {estudiante.usuario.perfil.pnombre}{' '}
            {estudiante.usuario.perfil.papellido}
          </Typography>
        </Stack>
      </Stack>
      <TableContainer>
        <Table sx={{ width: '100%' }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Actividades</TableCell>
              <TableCell width="100px" sx={{ fontWeight: 'bold' }}>
                Ponderación
              </TableCell>
              <TableCell width="130px" sx={{ fontWeight: 'bold' }}>
                Notas
              </TableCell>
              <TableCell width="150px" sx={{ fontWeight: 'bold' }}>
                Resultado
              </TableCell>
              <TableCell width="150px" sx={{ fontWeight: 'bold' }}>
                Porcentaje
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {actividades.map((item, index) => {
              return (
                <TableRow key={`calculate${item.id}`}>
                  <TableCell>{item.actividad.instrumento.nombre}</TableCell>
                  <TableCell>
                    {parseFloat(item.actividad.ponderacion).toFixed(2)}
                  </TableCell>
                  <TableCell key={`0${item.id}`}>
                    <FieldNotaEstudiante
                      id={`calculate-${item.id}`}
                      nota={parseInt(item.nota?.nota) ?? ''}
                      onChange={(text) => {
                        actividades[index].nota.nota = text === '' ? '0' : text;
                        setActividades([...actividades]);
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    {notaToPonderacionHelper(
                      parseInt(item.nota?.nota ?? '0'),
                      item.actividad.ponderacion,
                      entidadesStore.ajustes.ponderacion,
                    ).toFixed(2)}
                  </TableCell>
                  <TableCell>
                    {notaToPonderacionHelper(
                      notaToPonderacionHelper(
                        parseInt(item.nota?.nota ?? '0'),
                        item.actividad.ponderacion,
                        entidadesStore.ajustes.ponderacion,
                      ),
                      100,
                      entidadesStore.ajustes.ponderacion,
                    ).toFixed(2)}
                    %
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}></TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}></TableCell>
              <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                <label style={{ fontSize: '14pt', fontWeight: 'bold' }}>
                  Total
                </label>
              </TableCell>
              <TableCell>
                <Typography variant="h5" fontWeight="bold">
                  {notaDef.toFixed(2)}{' '}
                  <label style={{ fontSize: '12pt', fontWeight: 'normal' }}>
                    Pts
                  </label>
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h5" fontWeight="bold">
                  {notaToPonderacionHelper(
                    notaDef,
                    100,
                    entidadesStore.ajustes.ponderacion,
                  ).toFixed(2)}
                  %
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3} align="right" sx={{ fontWeight: 'bold' }}>
                <label style={{ fontSize: '14pt', fontWeight: 'bold' }}>
                  Definitiva
                </label>
              </TableCell>
              <TableCell>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  color={notaHoverColor(notaDef)}
                >
                  {notaDef.toFixed(0)}{' '}
                  <label style={{ fontSize: '12pt', fontWeight: 'normal' }}>
                    Pts
                  </label>
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  color={notaHoverColor(notaDef)}
                >
                  {notaToPonderacionHelper(
                    notaDef,
                    100,
                    entidadesStore.ajustes.ponderacion,
                  ).toFixed(0)}
                  %
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default CalculadoraNotasEstudianteView;
